<div class="undelete-container">
  <div class="title-wrapper">
    <h2 class="title-center">Undelete Clients and Integrations</h2>
  </div>

  <div class="center-toggle-group undelete-toggle-group pb-2">
    <mat-button-toggle-group
      #group="matButtonToggleGroup"
      [hideSingleSelectionIndicator]="true"
      (change)="onToggleActiveClientChange($event.value)">
      <mat-button-toggle
        value="true"
        aria-label="Active Clients"
        [checked]="showActiveClients">
        Active Clients
      </mat-button-toggle>
      <mat-button-toggle
        value="false"
        aria-label="Deleted Clients"
        [checked]="!showActiveClients">
        Deleted Clients
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>


  @if (!clientSelected) {
    @if (showActiveClients === true) {
      <div>
        <mat-form-field appearance="fill" class="med-wide-text-box" >
          <mat-label>Active Client</mat-label>
          <input type="text"
            matInput
            title="'Active Client'"
            [placeholder]="'Select Client...'"
            [matAutocomplete]="auto"
            [formControl]="clientFormControl">
            <mat-autocomplete autoActiveFirstOption
              #auto="matAutocomplete"
              (optionSelected)="selectClient($event.option.value)"
              [displayWith]="displayFnClient">
              @for (option of clientsFiltered | async; track option) {
                <mat-option [value]="option" >
                  {{option.clientDisplayName}}
                </mat-option>
              }
            </mat-autocomplete>
        </mat-form-field>
      </div>
    } @else {
        <div>
          <mat-form-field appearance="fill" class="med-wide-text-box" >
            <mat-label>Inactive Client</mat-label>
            <input type="text"
              matInput
              title="'Inactive Client'"
              [placeholder]="'Select Client...'"
              [matAutocomplete]="auto2"
              [formControl]="inactiveClientFormControl">
              <mat-autocomplete autoActiveFirstOption
                #auto2="matAutocomplete"
                (optionSelected)="selectClient($event.option.value)"
                [displayWith]="displayFnInactiveClient">
                @for (option of inactiveClientsFiltered | async; track option) {
                  <mat-option [value]="option" >
                    {{option.clientDisplayName}}
                  </mat-option>
                }
              </mat-autocomplete>
          </mat-form-field>
        </div>
    }
  }

  @if (clientSelected) {
    <div class="client-title">
        <h4>Client: {{selectedClient.clientDisplayName}}</h4>
        <button title="'Edit Client'"
          class="btn client-button"
          (click)="editClient()">
          <i class="bi bi-pencil"></i>
        </button>
    </div>
    @if (hasIntegrations) {
      <app-lt-png-table #integrationGrid [gridSettingsInput]="integrationGridSettings()" (selectionChange)="selectionChangeHandler($event)"></app-lt-png-table>

      <div class="center-button-group">
        <button matButton="elevated" [disabled]="!selectedIntegration" (click)="clickUndeleteButton()">Undelete Selected Integration</button>
      </div>
    }
    @if (hasNoIntegrations && !showActiveClients) {
      <div class="center-button-group">
        Client has no integrations.<br>
      </div>
      <div class="center-button-group">
        <button matButton="elevated" (click)="clickUndeleteClientButton()">Undelete Client</button>
      </div>
    }
    @if (hasNoIntegrations && showActiveClients && !showGoToRevisionHistory) {
      <div class="center-button-group">
        Client has no integrations.<br>
      </div>
      <div class="center-button-group">
        <button matButton="elevated" (click)="clickAddIntegration()">Add Integration</button>
      </div>
    }
    @if (showGoToRevisionHistory && showActiveClients) {
      <div class="center-button-group">
        All integrations have active versions. Use Revison History.<br>
      </div>
      <div class="center-button-group">
        <button matButton="elevated" (click)="clickGoToClient()">Go To Client</button>
      </div>
    }
  }

</div>

<app-lt-page-loading-message [loading]="pageLoading" [loadingFailed]="!pageLoading && !activeClients"></app-lt-page-loading-message>
